import { Link } from "react-router-dom";
import { t } from "ttag";

import { ADMIN_ROUTES, ROUTES } from "@/app/router";
import { EditSessionActions } from "@/features/coaching/components";
import { useEditSessionContext } from "@/features/coaching/context";
import { Header, LightbulbIcon, PenNewSquareIcon } from "@/shared/ui";

export const EditSessionHeader = () => {
  const {
    form: { getValues },
  } = useEditSessionContext();

  const isDraft = !getValues("published");

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: ADMIN_ROUTES.COACHING.BASE,
              icon: LightbulbIcon,
              label: t`Coaching lab`,
            },
            {
              href: ADMIN_ROUTES.COACHING.CREATE_SESSION,
              icon: PenNewSquareIcon,
              label: t`Edit session`,
            },
          ]}
        />

        <div className="flex items-center justify-between gap-x-8">
          <div className="flex items-center gap-2">
            <Link to={ROUTES.COACHING.OVERVIEW} className="md:hidden">
              <Header.GoBackButton />
            </Link>

            <Header.Title>{isDraft ? t`Draft` : t`Edit session`}</Header.Title>
          </div>

          <EditSessionActions position="header" />
        </div>

        <Header.Description>{t`Required fields *`}</Header.Description>
      </Header.Content>
    </Header.Root>
  );
};
